import { render, staticRenderFns } from "./MemberVideosList.vue?vue&type=template&id=689a95bd&"
import script from "./MemberVideosList.vue?vue&type=script&lang=js&"
export * from "./MemberVideosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports